$(document).ready(function() {
  $('li.single_image').on('click', function() {
    $('#product-grid').addClass('grid--1-col');
    $('#product-grid').removeClass('grid--2-col');
  });
  $('li.multicol_image').on('click', function() {
    $('#product-grid').addClass('grid--2-col');
    $('#product-grid').removeClass('grid--1-col');
  });

  $('.featured-carousel').owlCarousel({
    center: true,
    loop: true,
    items: 2,
    nav: true,
    autoplay: true,
    margin: 30,
    dots: false,
    navText: ["<img src='https://cdn.shopify.com/s/files/1/1626/4849/t/69/assets/next.svg'>","<img src='https://cdn.shopify.com/s/files/1/1626/4849/t/69/assets/next.svg'>"],
    responsive: {
      600: {
        center: false,
        nav: false,
        items: 4
      }
    }
  });

  $('.featured-carousel-main').owlCarousel({
    loop: true,
    items: 2,
    nav: true,
    autoplay: true,
    margin: 10,
    dots: false,
    navText: ["<img src='https://cdn.shopify.com/s/files/1/1626/4849/t/69/assets/next.svg'>","<img src='https://cdn.shopify.com/s/files/1/1626/4849/t/69/assets/next.svg'>"],
    responsive: {
      600: {
        center: false,
        nav: false,
        items: 4
      }
    }
  });

  $('.slider-owl').owlCarousel({
    items: 1,
    nav: false,
    autoplay: true,
    margin: 0,
    dots: false,
    loop: false
  });

  $('.slider-counter__link').click(function() {
    $('.slider-counter__link').removeClass('slider-counter__link--active');
    $('.slider-counter__link').removeAttr('aria-current');
    $(this).addClass('slider-counter__link--active');
    $(this).attr('aria-current', 'true');
  });

  $(window).scroll(function() {
    if ($(this).scrollTop() > 100) {
      $('#scroll').fadeIn();
    } else {
      $('#scroll').fadeOut();
    }
  });
  $('#scroll').click(function() {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });

  $('.toggle').click(function(e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).next().toggleClass('show');
    var $this = $(this);
    if ($this.next().hasClass('show')) {
      $this.next().removeClass('show');
      $this.next().slideUp(350);
    } else {
      $this.next().toggleClass('show');
      $this.next().slideToggle(350);
    }
  });

  $('.template-index button.slider-button.slider-button--next').trigger('click');

  $(document).on("mouseenter", ".swatch_ele", function() {
    var title = $(this).attr('title');
    var dataid = $(this).attr('data-atr-id');
    var dataurl = $(this).attr('data-atr-url');
    var datasrc = $(this).attr('data-src');
    var template = $('.templatefind').val();
    if (template == 'index') {
      datasrc = $(this).attr('dataindex-src');
    }
    $(this).parents('.card-wrapper').find('.main-img-card').attr('src', datasrc);
    $(this).parents('.card-wrapper').find('.main-img-card').attr('srcset', datasrc);
    $(this).parents('.card-wrapper').find('.reference-meta').hide();
    $(this).parents('.card-wrapper').find('.style-ref-form-' + dataid).show();
    $(this).parents('.card-wrapper').find('.swatch_ele').removeClass('current_swatch');
    $(this).addClass('current_swatch');
    $(this).parents('.card-wrapper').find('.linkabs').attr('href', dataurl);
    $(this).parents('.custom-field__product-swatches').find('span.dynamic_swatch').html(title);
  });

  // Quick-add from size box — appends item and updates totals only, no full rebuild
  $(document).on('click', '.size-box li.available-li', function() {
    this.cartNotification = document.querySelector('cart-notification');
    $(this).find('input').attr('checked', true);
    $(this).find('input').prop('checked', true);
    $(this).parent('ul').css('visibility', 'hidden');
    $(this).parent('ul').siblings('.procard_loaader').show();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: $(this).parent().parent().parent().parent().parent().parent("form").serialize(),
      success: function(response) {
        $('.size-box li.available-li').parent('ul').css('visibility', 'visible');
        $('.procard_loaader').hide();

        // Open drawer and update totals without rebuilding the whole list
        var cartNotification = document.querySelector('cart-notification');
        if (cartNotification) {
          cartNotification.renderContents(response);
        }
      },
      error: function() {
        $('.size-box li.available-li').parent('ul').css('visibility', 'visible');
        $('.procard_loaader').hide();
      }
    });
  });

  $('.header__icon.header__icon--cart').click(function(e) {
    e.preventDefault();
    $('#cart-notification').toggleClass('animate active');
    $('.point-to-icon').toggleClass('animate active');
    $('.overlay_body').toggle();
    $('body').toggleClass('drawer--open');
  });

  $('button.cart-notification__close').click(function() {
    $('.point-to-icon').removeClass('active');
    $('.point-to-icon').removeClass('animate');
    $('body').removeClass('drawer--open');
    $('.overlay_body').hide();
  });

  $('.inchesview').click(function() {
    $('.sizeincm').hide();
    $('.sizeininces').show();
  });
  $('.centimetersview').click(function() {
    $('.sizeincm').show();
    $('.sizeininces').hide();
  });

  $('.facet-checkbox-lable').click(function() {
    var v = $(this).attr('value');
    $('select.facet-filters__sort').val(v).trigger('change').trigger('click');
    $('#FacetFiltersForm').submit();
  });

  $('.wrapper-attachedproducts label').click(function() {
    var atr = $(this).attr('atr-variant');
    $(this).parents('.featured-product-reference').find('input[name="id"]').val(atr);
  });

  $(".ajaxrefcall").each(function(i, v) {
    var hn = $(this).attr('handle');
    var that = $(this);
    var baseUrl = window.location.href.includes('/en-nz/') ? '/en-nz/products/' : '/products/';
    jQuery.get(baseUrl + hn + '?view=ref-swatches', function(pro) {
      that.html(pro);
    }).fail(function(jqXHR, textStatus) {
      console.log('getJSON request failed! ' + textStatus);
    });
  });

  $(".size-swatches-ref").each(function(i, v) {
    var hn = $(this).attr('handle');
    var that = $(this);
    jQuery.get('/products/' + hn + '?view=colour-ref-size-swatches', function(pro) {
      that.html(pro);
    }).fail(function(jqXHR, textStatus) {
      console.log('getJSON request failed! ' + textStatus);
    });
  });

  $(".title-swatches-ref").each(function(i, v) {
    var hn = $(this).attr('handle');
    var that = $(this);
    jQuery.get('/products/' + hn + '?view=ref-product-title', function(pro) {
      that.html(pro);
    }).fail(function(jqXHR, textStatus) {
      console.log('getJSON request failed! ' + textStatus);
    });
  });

  $(".ajaxrefcallprice").each(function(i, v) {
    var hn = $(this).attr('handle');
    var that = $(this);
    var baseUrl = window.location.href.includes('/en-nz/') ? '/en-nz/products/' : '/products/';
    jQuery.get(baseUrl + hn + '?view=ref-product-prices', function(pro) {
      that.html(pro);
    }).fail(function(jqXHR, textStatus) {
      console.log('getJSON request failed! ' + textStatus);
    });
  });

  $(".ajaxrefcallwishlist").each(function(i, v) {
    var hn = $(this).attr('handle');
    var that = $(this);
    jQuery.get('/products/' + hn + '?view=ref-wishlist-icon', function(pro) {
      that.html(pro);
    }).fail(function(jqXHR, textStatus) {
      console.log('getJSON request failed! ' + textStatus);
    });
  });

});


// ─── Remove Item ────────────────────────────────────────────────────────────
$(document).on('click', '.removeitem', function(e) {
  e.preventDefault();
  const variantId = parseFloat($(this).data('variant-id'));
  const row = $(this).closest('.row-cart');

  row.css('opacity', '0.4');

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
      id: variantId,
      quantity: 0
    }
  })
  .then(function(cart) {
    row.remove();

    const total = Math.round(cart.items_subtotal_price / 100);
    $('.mini-cart-total-price span').text('$' + total + ' AUD');
    $('.cart-count-bubble span').html('(' + cart.item_count + ')');

    const msgEl = document.querySelector('.cart-msg-under');
    if (msgEl) {
      const fship = parseInt(msgEl.dataset.fship, 10);
      const isOver = cart.total_price >= fship;
      msgEl.innerHTML = isOver ? msgEl.dataset.msgOver : msgEl.dataset.msgUnder;
      const freeShippingRow = document.querySelector('.mini-cart-shipping-free');
      if (freeShippingRow) freeShippingRow.style.display = isOver ? 'flex' : 'none';
    }

    if (cart.items.length === 0) {
      $('div#cart-notification .cart-notification__links').hide();
      $('.cartempty').show();
    }

    $.get('/cart?view=cart_free_shipping', function(pro) {
      $('.productshippingbar').html(pro);
    });
  })
  .fail(function(err) {
    console.error('Failed to remove item:', err);
    row.css('opacity', '1');
  });
});


// ─── Utility ────────────────────────────────────────────────────────────────
function calcCarousel() {
  var headerHeight = $("#shopify-section-header").height();
  var announceHeight = $(".announcementbar-wrapper").height();
  var t = headerHeight + announceHeight + 10;
  $(".template-index .slideshow.banner--medium:not(.banner--adapt)").css('min-height', 'calc(100vh - ' + t + 'px)');
}

function recommCarousel() {
  $('.product-recommendations ul.addcarousel').addClass('owl-carousel');
  $('.product-ref-wrapper ul').addClass('owl-carousel');
  $('.product-recommendations ul.addcarousel, .product-ref-wrapper ul').owlCarousel({
    items: 1,
    nav: true,
    autoplay: true,
    margin: 9,
    center: true,
    stagePadding: 40,
    dots: false,
    loop: true,
    navText: ["<img src='https://cdn.shopify.com/s/files/1/1626/4849/t/69/assets/next.svg'>","<img src='https://cdn.shopify.com/s/files/1/1626/4849/t/69/assets/next.svg'>"]
  });

  $('.helpages-wrap').css('opacity', '1');
  var a = $('.helpages-wrap .act-true').attr('data-index');
  $('ul.helpages.list-menu').addClass('owl-carousel');
  $('ul.helpages.list-menu').owlCarousel({
    items: 3,
    nav: false,
    autoplay: false,
    autoWidth: true,
    startPosition: a,
    stagePadding: 20,
    dots: false,
    loop: true
  });
}

$(window).on('resize', function() {
  var win = $(this);
  if (win.width() > 1280) calcCarousel();
  if (win.width() < 768) recommCarousel();
});

$(document).ready(function() {
  var win = $(this);
  if (win.width() > 1280) calcCarousel();
  if (win.width() < 768) recommCarousel();
});

$(window).on('load', function() {
  var win = $(this);
  if (win.width() > 1280) {
    $('.template-product .product__media-list li:first-child button.deferred-media__poster').trigger('click');
  }
  if (win.width() < 767) {
    $('.product-recommendations .owl-nav button').html("<img src='https://cdn.shopify.com/s/files/1/1626/4849/t/69/assets/next.svg'>");
    $('.footer-block__heading').trigger('click');
  }
});


// ─── Close drawer on outside click ──────────────────────────────────────────
$(document).on('click', function(event) {
  if (!$(event.target).closest('#cart-notification').length &&
      !$(event.target).closest('#cart-icon-bubble').length) {
    $('#cart-notification').removeClass('animate active');
    $('.point-to-icon').removeClass('animate active');
    $('body').removeClass('drawer--open');
    $('.overlay_body').hide();
  }
});


// ─── Scroll header shrink ────────────────────────────────────────────────────
$(window).scroll(function() {
  if ($(window).scrollTop() >= 90) {
    $("body").addClass("removeTitle");
  } else {
    $("body").removeClass("removeTitle");
  }
});


// ─── Swatch hover (desktop) ──────────────────────────────────────────────────
if ($(window).width() >= 768) {
  $(document).on('mouseenter', '.swatch div', function() {
    if ($(this).data("image").indexOf("no-image") == -1) {
      $(this).parents('.card--product').find('img').attr('src', $(this).data("image"));
      $(this).parents('.card--product').find('img').attr('srcset', $(this).data("image"));
    }
  });
  $('.card__inner.mobile').remove();
}

if ($(window).width() <= 768) {
  $('.card__inner.desktop').remove();
  $('.card__inner.mobile').show();
  var owlscontext = $('.owl-carousels.mobile').owlCarousel({
    items: 1,
    nav: false,
    autoplay: false,
    responsiveClass: true,
    mouseDrag: true,
    touchDrag: true,
    smartSpeed: 800,
    loop: true,
    dots: true
  });

  $('ul.change_mob_layout.hidden-tablet-and-upa li').on('click', function() {
    owlscontext.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
    $('.owl-carousels.mobile').css('opacity', '0');
    owlscontext = $('.owl-carousels.mobile').owlCarousel({
      items: 1,
      nav: false,
      autoplay: false,
      responsiveClass: true,
      mouseDrag: true,
      touchDrag: true,
      smartSpeed: 800,
      loop: true,
      dots: true
    });
    setTimeout(function() {
      $('.owl-carousels.mobile').trigger('refresh.owl.carousel');
      $('.owl-carousels.mobile').css('opacity', '1');
    }, 150);
  });
}